export default __webpack_public_path__ + "static/media/constantcontact.08c03f64.png";